module.exports = __webpack_public_path__ + "static/media/whatsapp.188a2786.png";